import request from '@/utils/server'
  // 列表
  export function getStoreOperation(query) {
    return request({
      url: '/inventory/getStoreOperation',
      method: 'get',
     params: query
    })
  }